<div class="background" [ngClass]="scrollable? '' : 'not-scrollable'">
  <div class="popin-container" [ngClass]="darkmode? 'darkmode' : 'whitemode'">
    <div class="top-bar" [ngClass]="darkmode? 'darkmode-top-bar' : 'whitemode-top-bar'">
      <div class="qm-icon-x-01" (click)="onCrossClick()">
        <mat-icon style="font-size: 17px">clear icon</mat-icon>
      </div>
    </div>
    <ng-content></ng-content>
  </div>
</div>
